import { createChatBotMessage } from "react-chatbot-kit";

const config = {
  botName: "SQCBot",
  initialMessages: [
    createChatBotMessage("Hi! I'm SQCBot. Ask me anything!")
  ],
  customStyles: {
    botMessageBox: {
      backgroundColor: "#376B7E",
    },
    chatButton: {
      backgroundColor: "#5ccc9d",
    },
  },
  widgets: [
    {
      widgetName: "dummyWidget",
      widgetFunc: () => <div>No widgets here!</div>,
    }
  ]
};

export default config;
